package app.nestbridge.feature.progress.presentation

import androidx.compose.runtime.Composable
import app.nestbridge.feature.progress.screen.ProgressEvent
import app.nestbridge.feature.progress.screen.ProgressScreen
import app.nestbridge.feature.progress.screen.ProgressState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = ProgressScreen::class,
    scope = AppScope::class,
)
class ProgressPresenter @Inject constructor() : Presenter<ProgressState> {

    @Composable
    override fun present(): ProgressState {
        return ProgressState(
            eventSink = { _: ProgressEvent ->
                // No-op for now.
            },
        )
    }
}
